module.exports = __webpack_public_path__ + "img/相似宝贝示例图.bfabf4dd.jpeg";